module.exports = __webpack_public_path__ + "static/media/preview-black.dc259416.svg";